export default "__VITE_ASSET__DlTEsi6L__"